webpackJsonp([213534597649335],{

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var trim = __webpack_require__(32)
	
	var comma = ','
	var space = ' '
	var empty = ''
	
	/* Parse comma-separated tokens to an array. */
	function parse(value) {
	  var values = []
	  var input = String(value || empty)
	  var index = input.indexOf(comma)
	  var lastIndex = 0
	  var end = false
	  var val
	
	  while (!end) {
	    if (index === -1) {
	      index = input.length
	      end = true
	    }
	
	    val = trim(input.slice(lastIndex, index))
	
	    if (val || !end) {
	      values.push(val)
	    }
	
	    lastIndex = index + 1
	    index = input.indexOf(comma, lastIndex)
	  }
	
	  return values
	}
	
	/* Compile an array to comma-separated tokens.
	 * `options.padLeft` (default: `true`) pads a space left of each
	 * token, and `options.padRight` (default: `false`) pads a space
	 * to the right of each token. */
	function stringify(values, options) {
	  var settings = options || {}
	  var left = settings.padLeft === false ? empty : space
	  var right = settings.padRight ? space : empty
	
	  /* Ensure the last empty entry is seen. */
	  if (values[values.length - 1] === empty) {
	    values = values.concat(empty)
	  }
	
	  return trim(values.join(right + comma + left))
	}


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(147);
	var foreach = __webpack_require__(135);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	var toStr = Object.prototype.toString;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
	        /* eslint-disable no-unused-vars, no-restricted-syntax */
	        for (var _ in obj) { return false; }
	        /* eslint-enable no-unused-vars, no-restricted-syntax */
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			Object.defineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = props.concat(Object.getOwnPropertySymbols(map));
		}
		foreach(props, function (name) {
			defineProperty(object, name, map[name], predicates[name]);
		});
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(136);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(137);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(32);
	var paramCase = __webpack_require__(146);
	var information = __webpack_require__(149);
	var spaces = __webpack_require__(157);
	var commas = __webpack_require__(124);
	var nan = __webpack_require__(144);
	var is = __webpack_require__(158);
	
	module.exports = wrapper;
	
	function wrapper(h, node, prefix) {
	  var r;
	  var v;
	
	  if (typeof h !== 'function') {
	    throw new Error('h is not a function');
	  }
	
	  r = react(h);
	  v = vdom(h);
	
	  if (prefix === null || prefix === undefined) {
	    prefix = r === true || v === true ? 'h-' : false;
	  }
	
	  if (is('root', node)) {
	    if (node.children.length === 1 && is('element', node.children[0])) {
	      node = node.children[0];
	    } else {
	      node = {
	        type: 'element',
	        tagName: 'div',
	        properties: {},
	        children: node.children
	      };
	    }
	  } else if (!is('element', node)) {
	    throw new Error('Expected root or element, not `' + ((node && node.type) || node) + '`');
	  }
	
	  return toH(h, node, {
	    prefix: prefix,
	    key: 0,
	    react: r,
	    vdom: v,
	    hyperscript: hyperscript(h)
	  });
	}
	
	/* Transform a HAST node through a hyperscript interface
	 * to *anything*! */
	function toH(h, node, ctx) {
	  var selector = node.tagName;
	  var properties;
	  var attributes;
	  var children;
	  var property;
	  var elements;
	  var length;
	  var index;
	  var value;
	
	  properties = node.properties;
	  attributes = {};
	
	  for (property in properties) {
	    addAttribute(attributes, property, properties[property], ctx);
	  }
	
	  if (ctx.vdom === true) {
	    selector = selector.toUpperCase();
	  }
	
	  if (ctx.hyperscript === true && attributes.id) {
	    selector += '#' + attributes.id;
	    delete attributes.id;
	  }
	
	  if ((ctx.hyperscript === true || ctx.vdom === true) && attributes.className) {
	    selector += '.' + spaces.parse(attributes.className).join('.');
	    delete attributes.className;
	  }
	
	  if (typeof attributes.style === 'string') {
	    /* VDOM expects a `string` style in `attributes`
	     * See https://github.com/Matt-Esch/virtual-dom/blob/947ecf9/
	     * docs/vnode.md#propertiesstyle-vs-propertiesattributesstyle */
	    if (ctx.vdom === true) {
	      if (!attributes.attributes) {
	        attributes.attributes = {};
	      }
	
	      attributes.attributes.style = attributes.style;
	      delete attributes.style;
	    /* React only accepts `style` as object. */
	    } else if (ctx.react === true) {
	      attributes.style = parseStyle(attributes.style);
	    }
	  }
	
	  if (ctx.prefix) {
	    ctx.key++;
	    attributes.key = ctx.prefix + ctx.key;
	  }
	
	  elements = [];
	  children = node.children || [];
	  length = children.length;
	  index = -1;
	
	  while (++index < length) {
	    value = children[index];
	
	    if (is('element', value)) {
	      elements.push(toH(h, value, ctx));
	    } else if (is('text', value)) {
	      elements.push(value.value);
	    }
	  }
	
	  /* Ensure no React warnings are triggered for
	   * void elements having children passed in. */
	  return elements.length === 0 ? h(selector, attributes) : h(selector, attributes, elements);
	}
	
	/* Add `name` and its `value` to `props`. */
	function addAttribute(props, name, value, ctx) {
	  var info = information(name) || {};
	  var subprop;
	
	  /* Ignore nully, `false`, `NaN`, and falsey known
	   * booleans. */
	  if (
	    value === null ||
	    value === undefined ||
	    value === false ||
	    nan(value) ||
	    (info.boolean && !value)
	  ) {
	    return;
	  }
	
	  if (info.name) {
	    name = info.name;
	  } else if (ctx.react && !paramCasedReactProp(name)) {
	    name = camelCase(name);
	  } else {
	    name = paramCase(name);
	  }
	
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    /* Accept `array`.  Most props are space-separater. */
	    value = (info.commaSeparated ? commas : spaces).stringify(value);
	  }
	
	  /* Treat `true` and truthy known booleans. */
	  if (info.boolean && ctx.hyperscript === true) {
	    value = '';
	  }
	
	  if (info.name !== 'class' && (info.mustUseAttribute || !info.name)) {
	    if (ctx.vdom === true) {
	      subprop = 'attributes';
	    } else if (ctx.hyperscript === true) {
	      subprop = 'attrs';
	    }
	
	    if (subprop) {
	      if (props[subprop] === undefined) {
	        props[subprop] = {};
	      }
	
	      props[subprop][name] = value;
	
	      return;
	    }
	  }
	
	  props[info.propertyName || name] = value;
	}
	
	/* Check if `h` is `react.createElement`.  It doesn’t accept
	 * `class` as an attribute, it must be added through the
	 * `selector`. */
	function react(h) {
	  var node = h && h('div');
	  return Boolean(node && ('_owner' in node || '_store' in node) && node.key === null);
	}
	
	/* Check if `h` is `hyperscript`.  It doesn’t accept
	 * `class` as an attribute, it must be added through the
	 * `selector`. */
	function hyperscript(h) {
	  return Boolean(h && h.context && h.cleanup);
	}
	
	/**
	 * Check if `h` is `virtual-dom/h`.  It’s the only
	 * hyperscript “compatible” interface needing `attributes`. */
	function vdom(h) {
	  try {
	    return h('div').type === 'VirtualNode';
	  } catch (err) { /* Empty */ }
	
	  /* istanbul ignore next */
	  return false;
	}
	
	function parseStyle(value) {
	  var result = {};
	  var declarations = value.split(';');
	  var length = declarations.length;
	  var index = -1;
	  var declaration;
	  var prop;
	  var pos;
	
	  while (++index < length) {
	    declaration = declarations[index];
	    pos = declaration.indexOf(':');
	    if (pos !== -1) {
	      prop = camelCase(trim(declaration.slice(0, pos)));
	      result[prop] = trim(declaration.slice(pos + 1));
	    }
	  }
	
	  return result;
	}
	
	function paramCasedReactProp(name) {
	  var head = name.slice(0, 4);
	  return (head === 'data' || head === 'aria') && name.length > 4;
	}
	
	function camelCase(val) {
	  if (val.slice(0, 4) === '-ms-') {
	    val = 'ms-' + val.slice(4);
	  }
	
	  return val.replace(/-([a-z])/g, replace);
	}
	
	function replace($0, $1) {
	  return $1.toUpperCase();
	}


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	'use strict';
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	module.exports = function isNaN(value) {
		return value !== value;
	};


/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(57);
	
	var implementation = __webpack_require__(60);
	var getPolyfill = __webpack_require__(61);
	var shim = __webpack_require__(145);
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	define(implementation, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = implementation;


/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(60);
	
	module.exports = function getPolyfill() {
		if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) {
			return Number.isNaN;
		}
		return implementation;
	};


/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(57);
	var getPolyfill = __webpack_require__(61);
	
	/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */
	
	module.exports = function shimNumberIsNaN() {
		var polyfill = getPolyfill();
		define(Number, { isNaN: polyfill }, { isNaN: function () { return Number.isNaN !== polyfill; } });
		return polyfill;
	};


/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	'use strict';
	var KEBAB_REGEX = /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g;
	var REVERSE_REGEX = /-[a-z\u00E0-\u00F6\u00F8-\u00FE]/g;
	
	module.exports = exports = function kebabCase(str) {
		return str.replace(KEBAB_REGEX, function (match) {
			return '-' + match.toLowerCase();
		});
	};
	
	exports.reverse = function (str) {
		return str.replace(REVERSE_REGEX, function (match) {
			return match.slice(1).toUpperCase();
		});
	};


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(148);
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};
	
	var keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];
	
		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}
	
		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}
	
		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}
	
		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				return (Object.keys(arguments) || '').length === 2;
			}(1, 2));
			if (!keysWorksWithArguments) {
				var originalKeys = Object.keys;
				Object.keys = function keys(object) {
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					} else {
						return originalKeys(object);
					}
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),

/***/ 148:
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),

/***/ 149:
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = getPropertyInformation;
	
	/* Constants. */
	var USE_ATTRIBUTE = 0x1;
	var USE_PROPERTY = 0x2;
	var BOOLEAN_VALUE = 0x8;
	var NUMERIC_VALUE = 0x10;
	var POSITIVE_NUMERIC_VALUE = 0x20 | 0x10;
	var OVERLOADED_BOOLEAN_VALUE = 0x40;
	var SPACE_SEPARATED = 0x80;
	var COMMA_SEPARATED = 0x100;
	
	/* Map of properties. Names are camel-cased properties. */
	var propertyConfig = {
	  /* Standard Properties. */
	  abbr: null,
	  accept: COMMA_SEPARATED,
	  acceptCharset: SPACE_SEPARATED,
	  accessKey: SPACE_SEPARATED,
	  action: null,
	  allowFullScreen: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  allowTransparency: USE_ATTRIBUTE,
	  alt: null,
	  /* https://html.spec.whatwg.org/#attr-link-as */
	  as: null,
	  async: BOOLEAN_VALUE,
	  autoComplete: SPACE_SEPARATED,
	  autoFocus: BOOLEAN_VALUE,
	  autoPlay: BOOLEAN_VALUE,
	  capture: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  cellPadding: null,
	  cellSpacing: null,
	  challenge: USE_ATTRIBUTE,
	  charSet: USE_ATTRIBUTE,
	  checked: USE_PROPERTY | BOOLEAN_VALUE,
	  cite: null,
	  /* To set className on SVG elements, it's necessary to
	   * use .setAttribute; this works on HTML elements too
	   * in all browsers except IE8. */
	  className: USE_ATTRIBUTE | SPACE_SEPARATED,
	  cols: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  colSpan: null,
	  command: null,
	  content: null,
	  contentEditable: null,
	  contextMenu: USE_ATTRIBUTE,
	  controls: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://github.com/WICG/controls-list/blob/gh-pages/explainer.md */
	  controlsList: SPACE_SEPARATED,
	  coords: NUMERIC_VALUE | COMMA_SEPARATED,
	  crossOrigin: null,
	  /* For `<object />` acts as `src`. */
	  data: null,
	  dateTime: USE_ATTRIBUTE,
	  default: BOOLEAN_VALUE,
	  defer: BOOLEAN_VALUE,
	  dir: null,
	  dirName: null,
	  disabled: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  download: OVERLOADED_BOOLEAN_VALUE,
	  draggable: null,
	  dropzone: SPACE_SEPARATED,
	  encType: null,
	  form: USE_ATTRIBUTE,
	  formAction: USE_ATTRIBUTE,
	  formEncType: USE_ATTRIBUTE,
	  formMethod: USE_ATTRIBUTE,
	  formNoValidate: BOOLEAN_VALUE,
	  formTarget: USE_ATTRIBUTE,
	  frameBorder: USE_ATTRIBUTE,
	  headers: SPACE_SEPARATED,
	  height: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  hidden: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  high: NUMERIC_VALUE,
	  href: null,
	  hrefLang: null,
	  htmlFor: SPACE_SEPARATED,
	  httpEquiv: SPACE_SEPARATED,
	  id: USE_PROPERTY,
	  inputMode: USE_ATTRIBUTE,
	  /* Web Components */
	  is: USE_ATTRIBUTE,
	  isMap: BOOLEAN_VALUE,
	  keyParams: USE_ATTRIBUTE,
	  keyType: USE_ATTRIBUTE,
	  kind: null,
	  label: null,
	  lang: null,
	  list: USE_ATTRIBUTE,
	  loop: USE_PROPERTY | BOOLEAN_VALUE,
	  low: NUMERIC_VALUE,
	  manifest: USE_ATTRIBUTE,
	  marginHeight: NUMERIC_VALUE,
	  marginWidth: NUMERIC_VALUE,
	  max: null,
	  maxLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  media: USE_ATTRIBUTE,
	  mediaGroup: null,
	  menu: null,
	  method: null,
	  min: null,
	  minLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  multiple: USE_PROPERTY | BOOLEAN_VALUE,
	  muted: USE_PROPERTY | BOOLEAN_VALUE,
	  name: null,
	  nonce: null,
	  noValidate: BOOLEAN_VALUE,
	  open: BOOLEAN_VALUE,
	  optimum: NUMERIC_VALUE,
	  pattern: null,
	  ping: SPACE_SEPARATED,
	  placeholder: null,
	  /* https://html.spec.whatwg.org/#attr-video-playsinline */
	  playsInline: BOOLEAN_VALUE,
	  poster: null,
	  preload: null,
	  /* https://html.spec.whatwg.org/#dom-head-profile */
	  profile: null,
	  radioGroup: null,
	  readOnly: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://html.spec.whatwg.org/#attr-link-referrerpolicy */
	  referrerPolicy: null,
	  /* `rel` is `relList` in DOM */
	  rel: SPACE_SEPARATED | USE_ATTRIBUTE,
	  required: BOOLEAN_VALUE,
	  reversed: BOOLEAN_VALUE,
	  role: USE_ATTRIBUTE,
	  rows: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  rowSpan: POSITIVE_NUMERIC_VALUE,
	  sandbox: SPACE_SEPARATED,
	  scope: null,
	  scoped: BOOLEAN_VALUE,
	  scrolling: null,
	  seamless: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  selected: USE_PROPERTY | BOOLEAN_VALUE,
	  shape: null,
	  size: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  sizes: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* https://html.spec.whatwg.org/#attr-slot */
	  slot: null,
	  sortable: BOOLEAN_VALUE,
	  sorted: SPACE_SEPARATED,
	  span: POSITIVE_NUMERIC_VALUE,
	  spellCheck: null,
	  src: null,
	  srcDoc: USE_PROPERTY,
	  srcLang: null,
	  srcSet: USE_ATTRIBUTE | COMMA_SEPARATED,
	  start: NUMERIC_VALUE,
	  step: null,
	  style: null,
	  summary: null,
	  tabIndex: NUMERIC_VALUE,
	  target: null,
	  title: null,
	  translate: null,
	  type: null,
	  typeMustMatch: BOOLEAN_VALUE,
	  useMap: null,
	  value: USE_PROPERTY,
	  volume: POSITIVE_NUMERIC_VALUE,
	  width: USE_ATTRIBUTE | NUMERIC_VALUE,
	  wmode: USE_ATTRIBUTE,
	  wrap: null,
	
	  /* Non-standard Properties. */
	
	  /* `autoCapitalize` and `autoCorrect` are supported in
	   * Mobile Safari for keyboard hints. */
	  autoCapitalize: null,
	  autoCorrect: null,
	  /* `autoSave` allows WebKit/Blink to persist values of
	   * input fields on page reloads */
	  autoSave: null,
	  /* `itemProp`, `itemScope`, `itemType` are for Microdata
	   * support. See http://schema.org/docs/gs.html */
	  itemProp: USE_ATTRIBUTE | SPACE_SEPARATED,
	  itemScope: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  itemType: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `itemID` and `itemRef` are for Microdata support as well
	   * but only specified in the the WHATWG spec document.
	   * See https://html.spec.whatwg.org/multipage/
	   * microdata.html#microdata-dom-api */
	  itemID: USE_ATTRIBUTE,
	  itemRef: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `property` is supported for OpenGraph in meta tags. */
	  property: null,
	  /* `results` show looking glass icon and recent searches
	   * on input search fields in WebKit/Blink */
	  results: null,
	  /* IE-only attribute that specifies security
	   * restrictions on an iframe as an alternative to the
	   * sandbox attribute on IE < 10 */
	  security: USE_ATTRIBUTE,
	  /* IE-only attribute that controls focus behavior */
	  unselectable: USE_ATTRIBUTE,
	
	  /* Ancient. */
	  xmlLang: USE_ATTRIBUTE,
	  xmlBase: USE_ATTRIBUTE
	};
	
	/* Map of properties to attributes.
	 * Names are lower-case properties.
	 * Values are HTML attributes. */
	var propertyToAttributeMapping = {
	  xmlbase: 'xml:base',
	  xmllang: 'xml:lang',
	  classname: 'class',
	  htmlfor: 'for',
	  httpequiv: 'http-equiv',
	  acceptcharset: 'accept-charset'
	};
	
	/* Expand config. */
	var information = {};
	var property;
	var name;
	var config;
	
	getPropertyInformation.all = information;
	
	for (property in propertyConfig) {
	  name = lower(property);
	  name = propertyToAttributeMapping[name] || name;
	  config = propertyConfig[property];
	
	  information[name] = {
	    name: name,
	    propertyName: property,
	    mustUseAttribute: check(config, USE_ATTRIBUTE),
	    mustUseProperty: check(config, USE_PROPERTY),
	    boolean: check(config, BOOLEAN_VALUE),
	    overloadedBoolean: check(config, OVERLOADED_BOOLEAN_VALUE),
	    numeric: check(config, NUMERIC_VALUE),
	    positiveNumeric: check(config, POSITIVE_NUMERIC_VALUE),
	    commaSeparated: check(config, COMMA_SEPARATED),
	    spaceSeparated: check(config, SPACE_SEPARATED)
	  };
	}
	
	/* Get a config for a property. */
	function getPropertyInformation(propertyName) {
	  var insensitive = lower(propertyName);
	
	  return information[propertyToAttributeMapping[insensitive] || insensitive];
	}
	
	/* Check a mask. */
	function check(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	/* Lower-case a string. */
	function lower(value) {
	  return value.toLowerCase();
	}


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* Dependencies. */
	var has = __webpack_require__(142);
	var toH = __webpack_require__(143);
	
	/* Expose `rehype-react`. */
	module.exports = rehype2react;
	
	/**
	 * Attach a react compiler.
	 *
	 * @param {Unified} processor - Instance.
	 * @param {Object?} [options]
	 * @param {Object?} [options.components]
	 *   - Components.
	 * @param {string?} [options.prefix]
	 *   - Key prefix.
	 * @param {Function?} [options.createElement]
	 *   - `h()`.
	 */
	function rehype2react(options) {
	  var settings = options || {};
	  var createElement = settings.createElement;
	  var components = settings.components || {};
	
	  this.Compiler = compiler;
	
	  /* Compile HAST to React. */
	  function compiler(node) {
	    if (node.type === 'root') {
	      if (node.children.length === 1 && node.children[0].type === 'element') {
	        node = node.children[0];
	      } else {
	        node = {
	          type: 'element',
	          tagName: 'div',
	          properties: {},
	          children: node.children
	        };
	      }
	    }
	
	    return toH(h, node, settings.prefix);
	  }
	
	  /* Wrap `createElement` to pass components in. */
	  function h(name, props, children) {
	    var component = has(components, name) ? components[name] : name;
	    return createElement(component, props, children);
	  }
	}


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(32);
	
	exports.parse = parse;
	exports.stringify = stringify;
	
	var empty = '';
	var space = ' ';
	var whiteSpace = /[ \t\n\r\f]+/g;
	
	function parse(value) {
	  var input = trim(String(value || empty));
	
	  if (input === empty) {
	    return [];
	  }
	
	  return input.split(whiteSpace);
	}
	
	function stringify(values) {
	  return trim(values.join(space));
	}


/***/ }),

/***/ 32:
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),

/***/ 158:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable max-params */
	
	/* Expose. */
	module.exports = is;
	
	/* Assert if `test` passes for `node`.
	 * When a `parent` node is known the `index` of node */
	function is(test, node, index, parent, context) {
	  var hasParent = parent !== null && parent !== undefined;
	  var hasIndex = index !== null && index !== undefined;
	  var check = convert(test);
	
	  if (
	    hasIndex &&
	    (typeof index !== 'number' || index < 0 || index === Infinity)
	  ) {
	    throw new Error('Expected positive finite index or child node');
	  }
	
	  if (hasParent && (!is(null, parent) || !parent.children)) {
	    throw new Error('Expected parent node');
	  }
	
	  if (!node || !node.type || typeof node.type !== 'string') {
	    return false;
	  }
	
	  if (hasParent !== hasIndex) {
	    throw new Error('Expected both parent and index');
	  }
	
	  return Boolean(check.call(context, node, index, parent));
	}
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test);
	  }
	
	  if (test === null || test === undefined) {
	    return ok;
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test);
	  }
	
	  if (typeof test === 'function') {
	    return test;
	  }
	
	  throw new Error('Expected function, string, or object as test');
	}
	
	function convertAll(tests) {
	  var results = [];
	  var length = tests.length;
	  var index = -1;
	
	  while (++index < length) {
	    results[index] = convert(tests[index]);
	  }
	
	  return results;
	}
	
	/* Utility assert each property in `test` is represented
	 * in `node`, and each values are strictly equal. */
	function matchesFactory(test) {
	  return matches;
	
	  function matches(node) {
	    var key;
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests);
	  var length = checks.length;
	
	  return matches;
	
	  function matches() {
	    var index = -1;
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	}
	
	/* Utility to convert a string into a function which checks
	 * a given node’s type for said string. */
	function typeFactory(test) {
	  return type;
	
	  function type(node) {
	    return Boolean(node && node.type === test);
	  }
	}
	
	/* Utility to return true. */
	function ok() {
	  return true;
	}


/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MarkdownContent = __webpack_require__(107);
	
	var _MarkdownContent2 = _interopRequireDefault(_MarkdownContent);
	
	var _markdown = __webpack_require__(22);
	
	var _siteMetadata = __webpack_require__(72);
	
	var _Metadata = __webpack_require__(73);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _Page = __webpack_require__(108);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomePage = function HomePage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: (0, _siteMetadata.homePageTitle)(data),
	      imageSizes: (0, _markdown.markdownItemImageSizes)(data),
	      hidePageTitle: (0, _markdown.markdownItemFrontmatterlHidePageTitle)(data)
	    },
	    _react2.default.createElement(_Metadata2.default, (0, _siteMetadata.homePageMetadata)(data)),
	    _react2.default.createElement(_MarkdownContent2.default, { htmlAst: (0, _markdown.markdownItemHTMLAst)(data) })
	  );
	};
	
	HomePage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = HomePage;
	module.exports = exports['default'];

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HomePage = __webpack_require__(506);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _HomePage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['0.5ru'], ['0.5ru']);
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _elementBorder = __webpack_require__(53);
	
	var _elementBorder2 = _interopRequireDefault(_elementBorder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Blockquote = _styledComponents2.default.blockquote.withConfig({
	  displayName: 'Blockquote'
	})(['', ';', ';'], (0, _elementBorder2.default)(), (0, _cssapi.api)({
	  paddingLeft: (0, _cssapi.scope)(_templateObject)
	}));
	
	exports.default = Blockquote;
	module.exports = exports['default'];

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['-0.5ru'], ['-0.5ru']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['2.5ru'], ['2.5ru']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['s:smallprint'], ['s:smallprint']);
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Cite = _styledComponents2.default.cite.withConfig({
	  displayName: 'Cite'
	})(['display:block;::before{content:\'\u2E3B \';}', ';'], (0, _cssapi.api)({
	  marginTop: (0, _cssapi.scope)(_templateObject),
	  paddingLeft: (0, _cssapi.scope)(_templateObject2),
	  baseline: (0, _cssapi.scope)(_templateObject3)
	}));
	
	exports.default = Cite;
	module.exports = exports['default'];

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _linkProps = __webpack_require__(42);
	
	var _linkProps2 = _interopRequireDefault(_linkProps);
	
	var _BaseLink = __webpack_require__(51);
	
	var _BaseLink2 = _interopRequireDefault(_BaseLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FootnoteRef = (0, _styledComponents2.default)(_BaseLink2.default).withConfig({
	  displayName: 'FootnoteRef'
	})(['font-weight:bold;', ';', ';'], (0, _linkProps2.default)('c:text', 'c:highlight'), (0, _cssapi.api)({
	  baseline: 's:body'
	}));
	
	FootnoteRef.displayName = 'FootnoteRef';
	
	exports.default = FootnoteRef;
	module.exports = exports['default'];

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['1ru'], ['1ru']);
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _defaultBorder = __webpack_require__(41);
	
	var _defaultBorder2 = _interopRequireDefault(_defaultBorder);
	
	var _HorizontalRule = __webpack_require__(50);
	
	var _HorizontalRule2 = _interopRequireDefault(_HorizontalRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Footnotes = _styledComponents2.default.footer.withConfig({
	  displayName: 'Footnotes'
	})(['', ';', ';', '{display:none;}'], (0, _defaultBorder2.default)(), (0, _cssapi.api)({
	  paddingTop: (0, _cssapi.scope)(_templateObject)
	}), _HorizontalRule2.default);
	
	exports.default = Footnotes;
	module.exports = exports['default'];

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _defaultBorder = __webpack_require__(41);
	
	var _defaultBorder2 = _interopRequireDefault(_defaultBorder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HorizontalRule = _styledComponents2.default.hr.withConfig({
	  displayName: 'HorizontalRule'
	})(['border:none;position:relative;margin-bottom:0;', ';'], (0, _defaultBorder2.default)());
	exports.default = HorizontalRule;
	module.exports = exports['default'];

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['1ru'], ['1ru']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['s:lede'], ['s:lede']);
	
	var _cssapi = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(1);
	
	var _ramdaAdjunct = __webpack_require__(11);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rehypeReact = __webpack_require__(156);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _spaceChildrenV = __webpack_require__(34);
	
	var _spaceChildrenV2 = _interopRequireDefault(_spaceChildrenV);
	
	var _Blockquote = __webpack_require__(103);
	
	var _Blockquote2 = _interopRequireDefault(_Blockquote);
	
	var _Cite = __webpack_require__(104);
	
	var _Cite2 = _interopRequireDefault(_Cite);
	
	var _FootnoteRef = __webpack_require__(105);
	
	var _FootnoteRef2 = _interopRequireDefault(_FootnoteRef);
	
	var _Footnotes = __webpack_require__(106);
	
	var _Footnotes2 = _interopRequireDefault(_Footnotes);
	
	var _HorizontalRule = __webpack_require__(50);
	
	var _HorizontalRule2 = _interopRequireDefault(_HorizontalRule);
	
	var _ContentLink = __webpack_require__(113);
	
	var _ContentLink2 = _interopRequireDefault(_ContentLink);
	
	var _OrderedList = __webpack_require__(114);
	
	var _OrderedList2 = _interopRequireDefault(_OrderedList);
	
	var _UnorderedList = __webpack_require__(52);
	
	var _UnorderedList2 = _interopRequireDefault(_UnorderedList);
	
	var _Table = __webpack_require__(110);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _ContentTitlePrimary = __webpack_require__(116);
	
	var _ContentTitlePrimary2 = _interopRequireDefault(_ContentTitlePrimary);
	
	var _ContentTitleSecondary = __webpack_require__(117);
	
	var _ContentTitleSecondary2 = _interopRequireDefault(_ContentTitleSecondary);
	
	var _ContentTitleTertiary = __webpack_require__(118);
	
	var _ContentTitleTertiary2 = _interopRequireDefault(_ContentTitleTertiary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hrefIsBackref = (0, _ramda.test)(/^#fnref/);
	var isClassedAsFootnoteRef = (0, _ramda.test)(/footnote-ref/);
	var isClassedAsFootnotes = (0, _ramda.test)(/footnotes/);
	var idIsFootnote = (0, _ramda.test)(/^fn-/);
	var lhasIdProp = (0, _ramdaAdjunct.lensSatisfies)(idIsFootnote, (0, _ramda.lensPath)(['props', 'id']));
	var isListOfFootnotes = (0, _ramda.pipe)((0, _ramda.filter)((0, _ramda.both)(_ramdaAdjunct.isPlainObj, lhasIdProp)), _ramdaAdjunct.isNotEmpty);
	
	/* eslint-disable react/display-name, react/prop-types */
	var resolveAnchor = function resolveAnchor(theme) {
	  return function (_ref) {
	    var className = _ref.className,
	        href = _ref.href,
	        rest = _objectWithoutProperties(_ref, ['className', 'href']);
	
	    var Component = void 0;
	
	    if (isClassedAsFootnoteRef(className)) {
	      Component = _FootnoteRef2.default;
	    }
	
	    if (hrefIsBackref(href)) {
	      return null;
	    }
	
	    Component = Component || _ContentLink2.default;
	
	    return _react2.default.createElement(Component, _extends({}, rest, { theme: theme, href: href }));
	  };
	};
	
	var resolveDiv = function resolveDiv(theme) {
	  return function (_ref2) {
	    var className = _ref2.className,
	        rest = _objectWithoutProperties(_ref2, ['className']);
	
	    if (isClassedAsFootnotes(className)) {
	      return _react2.default.createElement(_Footnotes2.default, _extends({}, rest, { theme: theme }));
	    }
	    return _react2.default.createElement('div', _extends({ className: className }, rest));
	  };
	};
	
	var resolveOl = function resolveOl(theme) {
	  return function (_ref3) {
	    var children = _ref3.children;
	    return _react2.default.createElement(
	      _OrderedList2.default,
	      {
	        theme: theme,
	        size: isListOfFootnotes(children) ? 'small' : 'default'
	      },
	      children
	    );
	  };
	};
	/* eslint-enable react/display-name, react/prop-types */
	
	var renderAst = function renderAst(theme, ast) {
	  return new _rehypeReact2.default({
	    createElement: _react2.default.createElement,
	    components: {
	      h1: _ContentTitlePrimary2.default,
	      h2: _ContentTitleSecondary2.default,
	      h3: _ContentTitleTertiary2.default,
	      ol: resolveOl(theme),
	      ul: _UnorderedList2.default,
	      blockquote: _Blockquote2.default,
	      cite: _Cite2.default,
	      a: resolveAnchor(theme),
	      hr: _HorizontalRule2.default,
	      div: resolveDiv(theme),
	      table: _Table2.default
	    }
	  }).Compiler(ast);
	};
	
	var PageText = _styledComponents2.default.div.withConfig({
	  displayName: 'MarkdownContent__PageText'
	})(['div{', ';}div > p:first-of-type{font-weight:bold;', ';}', ',', ',', '{', ';}'], (0, _spaceChildrenV2.default)((0, _cssapi.scope)(_templateObject)), (0, _cssapi.api)({
	  baseline: (0, _cssapi.scope)(_templateObject2)
	}), _Blockquote2.default, _OrderedList2.default, _UnorderedList2.default, (0, _cssapi.api)({
	  marginH: (0, _cssapi.scope)(_templateObject)
	}));
	var MarkdownContent = function MarkdownContent(_ref4) {
	  var htmlAst = _ref4.htmlAst,
	      theme = _ref4.theme;
	  return _react2.default.createElement(
	    PageText,
	    null,
	    renderAst(theme, htmlAst)
	  );
	};
	MarkdownContent.propTypes = {
	  htmlAst: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _styledComponents.withTheme)(MarkdownContent);
	module.exports = exports['default'];

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Table = _styledComponents2.default.table.withConfig({
	  displayName: 'Table'
	})(['width:100%;thead{', ';}th{font-weight:normal;}'], (0, _cssapi.api)({
	  background: 'c:backgroundInverted',
	  color: 'c:textInverted',
	  borderColor: 'c:textInverted'
	}));
	
	exports.default = Table;
	module.exports = exports['default'];

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _TextLink = __webpack_require__(33);
	
	var _TextLink2 = _interopRequireDefault(_TextLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentLink = (0, _styledComponents2.default)(_TextLink2.default).withConfig({
	  displayName: 'ContentLink'
	})(['::before{content:\'\';position:absolute;transition:all 1s ease-in-out;z-index:-2;', ';}'], (0, _cssapi.api)({
	  bottom: 0,
	  top: 0,
	  left: '-4%',
	  right: '-4%'
	}));
	
	exports.default = ContentLink;
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['1ru'], ['1ru']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['-1ru'], ['-1ru']);
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _UnorderedList = __webpack_require__(52);
	
	var _UnorderedList2 = _interopRequireDefault(_UnorderedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var OrderedList = (0, _styledComponents2.default)(_UnorderedList2.default).withConfig({
	  displayName: 'OrderedList'
	})(['counter-reset:listItem;li:after{counter-increment:listItem;content:counter(listItem);position:absolute;text-align:center;', ';}'], (0, _cssapi.api)({
	  color: 'c:textInverted',
	  width: (0, _cssapi.scope)(_templateObject),
	  left: (0, _cssapi.scope)(_templateObject2),
	  top: 0
	}));
	
	exports.default = OrderedList;
	module.exports = exports['default'];

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['s:', ' 1'], ['s:', ' 1']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['1ru'], ['1ru']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['0.5ru'], ['0.5ru']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['-1ru'], ['-1ru']);
	
	var _cssapi = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _elementBorder = __webpack_require__(53);
	
	var _elementBorder2 = _interopRequireDefault(_elementBorder);
	
	var _spaceChildrenV = __webpack_require__(34);
	
	var _spaceChildrenV2 = _interopRequireDefault(_spaceChildrenV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var scaleMap = {
	  default: 'body',
	  small: 'smallprint'
	};
	
	var UnorderedList = _styledComponents2.default.ul.withConfig({
	  displayName: 'UnorderedList'
	})(['', ';', ';li{position:relative;list-style:none;', ';&::before{content:\'\';position:absolute;', ';', ';}}'], (0, _spaceChildrenV2.default)('0.5rem'), function (p) {
	  return (0, _cssapi.api)({
	    baseline: (0, _cssapi.scope)(_templateObject, scaleMap[p.size]),
	    paddingLeft: (0, _cssapi.scope)(_templateObject2)
	  })(p);
	}, (0, _cssapi.api)({
	  paddingLeft: (0, _cssapi.scope)(_templateObject3)
	}), (0, _cssapi.api)({
	  left: (0, _cssapi.scope)(_templateObject4),
	  height: (0, _cssapi.scope)(_templateObject2)
	}), (0, _elementBorder2.default)());
	
	UnorderedList.propTypes = {
	  size: _propTypes2.default.string
	};
	
	UnorderedList.defaultProps = {
	  size: 'default'
	};
	
	exports.default = UnorderedList;
	module.exports = exports['default'];

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['s:contentPrimaryTitle'], ['s:contentPrimaryTitle']);
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ContentTitlePrimary = _styledComponents2.default.h2.withConfig({
	  displayName: 'ContentTitlePrimary'
	})(['', ';'], (0, _cssapi.api)({
	  baseline: (0, _cssapi.scope)(_templateObject)
	}));
	
	exports.default = ContentTitlePrimary;
	module.exports = exports['default'];

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['s:contentSecondaryTitle'], ['s:contentSecondaryTitle']);
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ContentTitleSecondary = _styledComponents2.default.h3.withConfig({
	  displayName: 'ContentTitleSecondary'
	})(['', ';'], (0, _cssapi.api)({
	  baseline: (0, _cssapi.scope)(_templateObject)
	}));
	
	exports.default = ContentTitleSecondary;
	module.exports = exports['default'];

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['s:contentTertiaryTitle'], ['s:contentTertiaryTitle']);
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ContentTitleTertiary = _styledComponents2.default.h4.withConfig({
	  displayName: 'ContentTitleTertiary'
	})(['', ';'], (0, _cssapi.api)({
	  baseline: (0, _cssapi.scope)(_templateObject)
	}));
	
	exports.default = ContentTitleTertiary;
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cssapi = __webpack_require__(4);
	
	var _ramda = __webpack_require__(1);
	
	var _ramdaAdjunct = __webpack_require__(11);
	
	var _styledComponents = __webpack_require__(3);
	
	var _formatting = __webpack_require__(49);
	
	var defaultBorder = function defaultBorder(api) {
	  return function () {
	    var edges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['top'];
	    var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'c:text';
	
	    var edgeStyles = (0, _ramda.reduce)(function (edgeStylesObj, edge) {
	      return (0, _ramda.assoc)('border' + (0, _formatting.firstToUpper)(edge), '5px solid ' + color, edgeStylesObj);
	    }, {}, (0, _ramdaAdjunct.ensureArray)(edges));
	    return (0, _styledComponents.css)(['', ';'], api(edgeStyles));
	  };
	};
	
	exports.default = (0, _cssapi.mixin)(defaultBorder);
	module.exports = exports['default'];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['1ru solid c:text'], ['1ru solid c:text']);
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var elementBorder = function elementBorder(api) {
	  return function () {
	    return (0, _styledComponents.css)(['', ';'], api({
	      borderLeft: (0, _cssapi.scope)(_templateObject)
	    }));
	  };
	};
	
	exports.default = (0, _cssapi.mixin)(elementBorder);
	module.exports = exports['default'];

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _graphql = __webpack_require__(58);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _HomePage = __webpack_require__(507);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HomePage2.default;
	
	// Note: Ideally this would be in its own file and imported from a Page
	// Container, but Gatsby preprocesses the pages looking for a graphql call.
	// Moving it anywhere else results in an error.
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-4f1a6d509d5134735bd0.js